// extracted by mini-css-extract-plugin
export default {"item":"NewsItem_item__3IwHr","default_image":"NewsItem_default_image__YgjVg"};